<template>
  <div>test</div>
</template>
<script>
export default {
  data () {
    return {}
  },
  beforeRouteEnter: (to, from, next) => {
    console.log('test')
    setTimeout(function () {
      next()
    }, 300)
  }
}
</script>




// WEBPACK FOOTER //
// Test.vue?76b6f1b5